import { render, staticRenderFns } from "./PosIndex.vue?vue&type=template&id=6992a48b&scoped=true"
import script from "./PosIndex.vue?vue&type=script&lang=js"
export * from "./PosIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6992a48b",
  null
  
)

export default component.exports